module.exports = __webpack_public_path__ + "img/icon_empty_notes.d88f9653.png";